<template>
	<div class="images">
		<table class="images__table">
			<tr>
				<th style="width: 80%">타이틀</th>
				<th style="width: 20%">이미지수</th>
			</tr>
			<tr>
				<td>
					<label>
						<input
							@input="emitEvent"
							placeholder="이미지 업로드란의 타이틀을 설정해주세요"
							v-model="image.title"
							type="text"
						/>
					</label>
				</td>
				<td style="text-align: center; vertical-align: middle">
					<label>
						<input
							style="text-align: center"
							type="text"
							@input="checkCount"
							v-model="image.count"
						/>
					</label>
				</td>
			</tr>
		</table>
	</div>
</template>
<script>
	export default {
		name: 'ApplyImageUpload',
		data() {
			return {
				image: { title: '', count: 1 },
			};
		},
		methods: {
			setImageUpload(item) {
				this.image = item;
				this.emitEvent();
			},
			isEmptyValue() {
				return this.image.title.trim().length === 0;
			},
			checkCount() {
				if (
					isNaN(this.image.count) ||
					this.image.count.trim().length === 0
				) {
					this.image.count = '';
				} else if (this.image.count < 1) {
					this.image.count = 1;
				} else if (this.image.count > 3) {
					this.image.count = 3;
				}

				this.emitEvent();
			},
			emitEvent() {
				this.$emit('change', this.image);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.images__table {
		margin: 1em 0;
		border-top: 1px solid #ebebed;
		table-layout: fixed;

		th {
			padding: 1em;
			text-align: center;
			background: #f4f7fa;
			color: #657088;
			border-bottom: 1px solid #ebebed;
			vertical-align: middle;
		}

		td {
			padding: 1em;
			color: #657088;
			border-bottom: 1px solid #ebebed;
		}
	}
</style>
